<template>
  <div class="time-range-select-wrapper">
    <el-date-picker v-model="time" type="datetimerange" value-format="timestamp" :size="size"
        range-separator="至" @change="emit"
        :unlink-panels="true"
        :editable="false"
        :time-arrow-control="true"
        :clearable="false"
        :picker-options="pickerOptions"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        popper-class="popper-class">
    </el-date-picker>
  </div>
</template>

<script>
const moment = require('moment')

export default {
  name: 'TimeRangeSelect',
  props: ['size', 'values'],
  data: function () {
    return {
      // time: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
      time: [moment().subtract(1, 'month').valueOf(), moment().valueOf()],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  methods: {
    emit () {
      if (this.time[0] === this.time[1]) {
        this.time[1] += 1000
      }
      // this.time[0] = moment(this.time[0]).startOf('day').valueOf()
      // this.time[1] = moment(this.time[1]).endOf('day').add(1, 'ms').valueOf()
      console.log(this.time[0], this.time[1], '---day')
      this.$emit('input', this.time)
    }
  },
  created () {
    console.log(this.time, 'time desua')
    this.$forceUpdate()
    if (Array.isArray(this.values)) {
      console.log('koko')
      this.time = []
      this.time.push(this.values[0])
      this.time.push(this.values[1])
    } else {
      // this.time[0] = moment().startOf('month').toDate()
      // this.time[1] = moment().endOf('month').add(1, 'ms').toDate()
    }
  }
}
</script>

<style lang="scss" scoped>
.time-range-select-wrapper{
  margin-right: 10px;
}
</style>

<style rel="stylesheet/scss" lang="scss">
.popper-class {
  .el-picker-panel__footer {
    .el-button--text {
      display: none;
    }
  }
}
</style>
